// extracted by mini-css-extract-plugin
export default {"whitespace-pre-wrap":"HomeAudit_whitespace-pre-wrap_jABBr","w-full":"HomeAudit_w-full_JtKYf","break-words":"HomeAudit_break-words_gwH4_"};